// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QLAQ","rootNoMargin":"styles_rootNoMargin__1T5bx"};